import { Card, Col, Row, Tab, Tabs } from "react-bootstrap";
import { Link } from "react-router-dom";
import useFetch from "../../hooks/useFetch";
import { useEffect, useState } from "react";
import Autosuggest from "react-autosuggest";

import styles from "../../FacilityProfile.module.css";
import { create } from "../../services/upload-files.service";

const FacilityProfile = ({ state }) => {
  const { data, isLoading } = useFetch(
    `facilities/profile/${state ? state.id : ""}`
  );
  const { data: employeeList, isLoading: loading } = useFetch(`employee/not_in_facilities/${state ? state.id : ""}`);
  const { data: depEmp, isLoading: depEmpLoading } = useFetch(
    `facilities/Listed_employee?id=${state ? state.id : ""}`
  );
  const [isSaving, setIsSaving] = useState(false);
  const [users, setUsers] = useState([]);
  const [message, setMessage] = useState({});

  useEffect(() => {
    if (employeeList && employeeList.results) {
      setUsers(employeeList.results);
    }
  }, [employeeList]);

  const [value, setValue] = useState("");
  const [suggestions, setSuggestions] = useState([]);

  const saveData = (dataToSave) => {
    setIsSaving(true); // Set saving indicator
    create(dataToSave, "facilities/AddEmployeeToFacilities")
      .then((res) => {
        if (res.message === 'Success') {
          setMessage({ "message": "Invite Sent" })
          setValue("");
          setTimeout(() => { setMessage({}) }, 2000)

        }
      })
      .finally(() => {
        setIsSaving(false); // Reset saving indicator
      });
  };
  const inviteUser = async (userId) => {
    try {
      const submitData = {
        employee_id: userId,
        facilities_id: state && state.id,
      };
      setIsSaving(true); // Set saving indicator
      saveData(submitData);
    } catch (error) {
      console.error("Error inviting user:", error);
    }
  };

  if (isLoading || loading || depEmpLoading) {
    return (
      <>
        <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
          <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
            <h1 className="h2">
              <i className="fa-solid fa-spinner fa-spin"></i>
            </h1>
          </div>
        </main>
      </>
    );
  }

  const formatNumber = (value) => {
    let values = value.replace(/[^\d.]/g, "");
    const stringValue = values.toString();
    const parts = stringValue.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  };
  const getSuggestions = (value) => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;

    return inputLength === 0
      ? []
      : users.filter((user) => user.name.toLowerCase().includes(inputValue));
  };

  const renderSuggestion = (suggestion) => <div>{suggestion.name}</div>;

  const onSuggestionsFetchRequested = ({ value }) => {
    setSuggestions(getSuggestions(value));
  };

  const onSuggestionsClearRequested = () => {
    setSuggestions([]);
  };

  const onSuggestionSelected = (event, { suggestion }) => {
    setValue(suggestion.name);
  };

  const onChange = (event, { newValue }) => {
    setValue(newValue);
  };

  const inputProps = {
    placeholder: "Type a user name",
    value,
    onChange: onChange,
  };

  const renderInputComponent = (inputProps) => (
    <div>
      <input {...inputProps} className={styles.customInput} />
    </div>
  );

  const renderSuggestionsContainer = ({ containerProps, children, query }) => (
    <div {...containerProps} className={styles.suggestionsContainer}>
      {children}
    </div>
  );

  return (
    <>
      <div className="row">
        <div className="col-sm-8">
          {/* <div className="col-sm-12">
                        <Card className="mb-4">
                            <Card.Body className="facility-profile">
                                <Card.Img className="facility-circle-img" variant="top" src="https://dummyimage.com/200x200/a19ca1/fff" />
                                <div className="facility-inner">
                                    <span><b>{state.name}</b></span>
                                    <span>
                                        <b>{state.location}</b>
                                    </span>
                                    <span>Fuel station to refuel vehicle </span>
                                </div>
                            </Card.Body>
                        </Card>
                    </div> */}

          <Row xs={1} md={3} className="g-4">
            {data && data.length > 0
              ? data.map((val, idx) => (
                <Col key={idx}>
                  <Card>
                    <Card.Body>
                      <div className="facility-inner-child">
                        <Card.Img
                          variant="top"
                          src="https://dummyimage.com/200x200/a19ca1/fff"
                        />
                        <div className="facility-inner-child-content">
                          <span>{val.display_name} </span>
                          <span>
                            <b>
                              {" "}
                              {val.total_amount
                                ? formatNumber(val.total_amount.toString())
                                : "0"}
                            </b>
                            {val.total_amount ? (
                              <small>
                                {val.sub_category === "GHG Emissions"
                                  ? "KgC02e"
                                  : val.sub_category === "Air Quality"
                                    ? "KgC02e"
                                    : val.sub_category === "Energy Management"
                                      ? "KWh"
                                      : val.sub_category ===
                                        "Water & Wastewater Management"
                                        ? "Gallons"
                                        : val.sub_category ===
                                          "Waste & Hazardous Materials Management"
                                          ? "Metric Ton"
                                          : "KgC02e"}
                              </small>
                            ) : (
                              ""
                            )}
                          </span>

                          {/* <Link to="/assetanalyticdetail" state={{ id: val.id, subCategoryName: val.sub_category, stateid: state }}>View Data</Link> */}
                          <Link
                            to={
                              val.sub_category === "GHG Emissions"
                                ? "/assetanalyticdetail"
                                : val.sub_category === "Air Quality"
                                  ? "/airquality"
                                  : val.sub_category === "Energy Management"
                                    ? "/energymanagement"
                                    : val.sub_category ===
                                      "Water & Wastewater Management"
                                      ? "/watermanagement"
                                      : val.sub_category ===
                                        "Waste & Hazardous Materials Management"
                                        ? "/hazardousmanagement"
                                        : "/defaultLink"
                            }
                            state={{
                              id: val.id,
                              subCategoryName: val.sub_category,
                              displayName: val.display_name,
                              stateid: state,
                            }}
                          >
                            View Data
                          </Link>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              ))
              : ""}
          </Row>
        </div>
        <div className="col-sm-4">
          <div className="facility-inner-tabs">
            <Tabs defaultActiveKey={1} id="uncontrolled-tab-example">
              <Tab eventKey={1} title="Users">
                <div className="users-box">
                  <i class="fa-solid fa-circle-user"></i>
                  {/* <span>No member onboarded yet</span> */}
                  <h2>User List</h2>
                  <ul className="assets-user-ul">
                    {depEmp && depEmp.result && depEmp.result.length > 0 ? (
                      depEmp.result.map((user, idx) => (
                        <li
                          key={idx}
                          className="assets-user-list"
                        >
                          <div>{user}</div>
                        </li>
                      ))
                    ) : (
                      <span>No Employee</span>
                    )}
                  </ul>

                </div>
              </Tab>
              <Tab eventKey={2} title="Invite">
                <div className="users-box2">
                  {message.message && <span className="success">{message.message}</span>}
                  <Autosuggest
                    suggestions={suggestions}
                    onSuggestionsFetchRequested={onSuggestionsFetchRequested}
                    onSuggestionsClearRequested={onSuggestionsClearRequested}
                    getSuggestionValue={(suggestion) => suggestion.name}
                    renderSuggestion={renderSuggestion}
                    onSuggestionSelected={onSuggestionSelected}
                    inputProps={inputProps}
                    renderInputComponent={renderInputComponent}
                    renderSuggestionsContainer={renderSuggestionsContainer}
                  />
                  {value &&
                    (isSaving ? (
                      <button
                        className={styles.waitingbutton}
                        disabled
                      >
                        Waiting...
                      </button>
                    ) : (
                      <button
                        className={styles.sendinvitebtn}
                        onClick={() =>
                          inviteUser(
                            users.find((user) => user.name === value).id
                          )
                        }
                      >
                        Send Invite
                      </button>
                    ))}
                </div>
              </Tab>
            </Tabs>
          </div>
          {/* <div className="addgoalfacility">
                        <div className="topaddgoalfacility">
                            <div className="topaddgoalfacilityimg">
                                <img src="https://dummyimage.com/200x200/a19ca1/fff" />
                            </div>
                            <div className="topaddgoalfacilitytext">
                                <span>Goals</span>
                                <span>0</span>
                            </div>
                        </div>
                        <div className="bottomaddgoalfacility">
                            <span>You have not set any goals for this {state.name} yet.</span>
                            <Link to={"/creategoal"}><button className="buttonline">+ Add goals</button></Link>
                        </div>
                    </div> */}
        </div>
      </div>
    </>
  );
};

export default FacilityProfile;
